import { CanMatchFn, Route, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';
import { filter, take, map } from 'rxjs/operators';

export const roleGuard: CanMatchFn = (route: Route) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const required = (route.data?.['roles'] as string[] | undefined) ?? [];
  if (required.length === 0) return true;

  //if (!auth.isLoggedIn()) return router.createUrlTree(['/login']);

  //return auth.hasRole(required) ? true : router.createUrlTree(['/forbidden']);

  return auth.isInitialized$.pipe(
      filter(isInitialized => isInitialized === true),
      take(1),
      map(() => {
          const user = auth.user;
            
            if(!user){
                router.navigate(['/login']);
                return false;
            }

            return auth.hasRole(required) ? true : router.createUrlTree(['/forbidden']);
            //return true;
      })
  );
};
